import { getOpinionFilterCond } from '@op/services';
import { gameInfoType } from '@op/types/common';
import { openWindowUrl } from '@op/utils/url';
import { useEffect, useState } from 'react';

export default function useSteamUrl({ gameInfo }: { gameInfo: gameInfoType }) {
  const [value, setValue] = useState<null | string>(null);

  async function goToSteamUrl() {
    if (value === null) {
      const url = await requestGameSteamUrl();
      openWindowUrl(url);
    } else {
      openWindowUrl(value);
    }
  }

  function requestGameSteamUrl() {
    const { edition_unified_id, entity_type, id_type } = gameInfo || {};
    if (edition_unified_id) {
      return getOpinionFilterCond({
        edition_unified_id,
        entity_type,
        id_type,
        request_type: ['game_steam_url'],
        un_request_type: ['topic_trans'],
      })
        .then((data: any) => {
          const url = data?.game_steam_url || null;
          setValue(url);
          return url;
        })
        .catch(() => {
          setValue(null);
        });
    }
  }

  useEffect(() => {
    requestGameSteamUrl();
  }, [gameInfo]);

  return { goToSteamUrl };
}
